import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { BadgeComponent } from '../../../components/badge/badge.component';
import { MessagesCounterService } from '../../../services/messages/messages-counter.service';

/**
 * This component handles putting the number on the envelope in the menu based on the number of unread messages.
 */
@Component({
  selector: 'td-wb-messages-counter',
  templateUrl: 'messages-counter.component.html',
  imports: [
    TranslateDirective,
    BadgeComponent
  ]
})
export class MessagesCounterComponent implements OnInit, OnDestroy {
  private readonly messagesCounterService = inject(MessagesCounterService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  messagesCounter: number;
  private messageCounterSubscription: Subscription;

  ngOnInit(): void {
    this.messageCounterSubscription = this.messagesCounterService.onMessagesCounterUpdate.subscribe((counter: number): void => {
      this.messagesCounter = counter;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.messageCounterSubscription?.unsubscribe();
  }
}
